export interface ITableParam {
  title: string;
  key: string | string[];
  valueRule?: (arg: any, dataItem: any) => any;
}

const stringifyCsvValue = (value: any): string => {
  if (value === null || value === undefined) {
    return '""';
  }

  return `"${String(value).replace(/"/g, '""')}"`;
};

const CSV_DATA_URI_PREFIX = 'data:text/csv;charset=utf-8,';

const toCsvParser = <T>(tableParams: ITableParam[], data: T[]): string => {
  const tableHeaders = tableParams.map((tableParam) => {
    return tableParam.title;
  });
  const tableContent = data.map((dataItem: any) => {
    const line = tableParams.map((tableParamsItem) => {
      let currentItem: any;
      if (Array.isArray(tableParamsItem.key)) {
        currentItem = dataItem;
        tableParamsItem.key.forEach((tableParamsItemKey: string) => {
          currentItem = currentItem ? currentItem[tableParamsItemKey] : null;
        });
      } else {
        currentItem = dataItem[tableParamsItem.key];
      }
      if (tableParamsItem.valueRule) {
        currentItem = tableParamsItem.valueRule(currentItem, dataItem);
      }
      return stringifyCsvValue(currentItem);
    });
    return line;
  });
  const csvContent = [tableHeaders.map(stringifyCsvValue), ...tableContent]
    .map((e: string[]) => e.join(','))
    .join('\n');

  return `${CSV_DATA_URI_PREFIX}${encodeURIComponent(csvContent)}`;
};

export default toCsvParser;
